module.exports = __webpack_public_path__ + "img/you.b68f3049.png";